import React from 'react';
export const WhyChooseMe = () => {
  return <>
      {/* Problem Section */}
      <section className="py-20 bg-gray-50" data-id="element-625">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-626">
          <div className="text-center mb-16" data-id="element-627">
            <h2 className="text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-628">
              Here's What You're Up Against
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-629">
              Most copywriters create the same problems over and over again.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-630">
            <div className="bg-white p-8 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 text-center" data-id="element-631">
              <div className="text-5xl mb-6" data-id="element-632">🤖</div>
              <h3 className="text-xl font-bold mb-4 text-black-600" data-id="element-633">
                Robotic Copy
              </h3>
              <p className="text-gray-600" data-id="element-634">
                They write like they're talking to algorithms, not humans.
                Corporate jargon that puts people to sleep.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 text-center" data-id="element-635">
              <div className="text-5xl mb-6" data-id="element-636">📋</div>
              <h3 className="text-xl font-bold mb-4 text-Black-600" data-id="element-637">
                Template Thinking
              </h3>
              <p className="text-gray-600" data-id="element-638">
                They use the same formulas for everyone. Your unique brand gets
                lost in generic messaging.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 text-center" data-id="element-639">
              <div className="text-5xl mb-6" data-id="element-640">💸</div>
              <h3 className="text-xl font-bold mb-4 text-Black-600" data-id="element-641">
                No Real Results
              </h3>
              <p className="text-gray-600" data-id="element-642">
                They focus on "engagement" and "industry jargon" instead of
                actual conversions and revenue.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 text-center" data-id="element-643">
              <div className="text-5xl mb-6" data-id="element-644">👻</div>
              <h3 className="text-xl font-bold mb-4 text-Black-600" data-id="element-645">
                Disappearing Act
              </h3>
              <p className="text-gray-600" data-id="element-646">
                They deliver the work and vanish. No optimization, no follow-up,
                no real partnership.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Solution Section */}
      <section className="py-20 bg-white" data-id="element-647">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-648">
          <div className="text-center mb-16" data-id="element-649">
            <h2 className="text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-650">
              Here's How We're Different
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-651">
              A completely different approach that actually gets results.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-652">
            <div className="bg-white p-6 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2" data-id="element-653">
              <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#16a34a] text-white mb-4" data-id="element-654">
                <span className="font-bold text-xl" data-id="element-655">1</span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#2c3e50]" data-id="element-656">
                We Write Human-to-Human
              </h3>
              <p className="text-base text-gray-600 mb-3" data-id="element-657">
                Your copy will sound like a conversation with a trusted friend,
                not a corporate press release.
              </p>
              <p className="text-base text-gray-600" data-id="element-658">
                <strong data-id="element-659">The result:</strong> People actually read your stuff and
                take action.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2" data-id="element-660">
              <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#16a34a] text-white mb-4" data-id="element-661">
                <span className="font-bold text-xl" data-id="element-662">2</span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#2c3e50]" data-id="element-663">
                We Study Your Audience First
              </h3>
              <p className="text-base text-gray-600 mb-3" data-id="element-664">
                Before writing a single word, We dive deep into who your
                customers really are and what they actually want to hear.
              </p>
              <p className="text-base text-gray-600" data-id="element-665">
                <strong data-id="element-666">The result:</strong> Copy that resonates because it
                speaks their language.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2" data-id="element-667">
              <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#16a34a] text-white mb-4" data-id="element-668">
                <span className="font-bold text-xl" data-id="element-669">3</span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#2c3e50]" data-id="element-670">
                We Focus on Revenue, Not Vanity
              </h3>
              <p className="text-base text-gray-600 mb-3" data-id="element-671">
                Our copy is designed to convert browsers into buyers. Every word
                has a purpose: driving action.
              </p>
              <p className="text-base text-gray-600" data-id="element-672">
                <strong data-id="element-673">The result:</strong> Measurable ROI from your copy
                investment.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2" data-id="element-674">
              <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#16a34a] text-white mb-4" data-id="element-675">
                <span className="font-bold text-xl" data-id="element-676">4</span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#2c3e50]" data-id="element-677">
                We're Your Long-Term Partner
              </h3>
              <p className="text-base text-gray-600 mb-3" data-id="element-678">
                We stick around to optimize, refine, and improve your copy based
                on real performance data.
              </p>
              <p className="text-base text-gray-600" data-id="element-679">
                <strong data-id="element-680">The result:</strong> Copy that gets better over time,
                not worse.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Comparison Section */}
      <section className="py-20 bg-gray-50" data-id="element-681">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-682">
          <div className="text-center mb-16" data-id="element-683">
            <h2 className="text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-684">
              Our Team vs. Other Copywriters
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-685">
              See the difference for yourself.
            </p>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-686">
            <div className="bg-[#1E1E1E] text-white p-6 text-center" data-id="element-687">
              <h3 className="text-2xl font-bold" data-id="element-688">What You Actually Get</h3>
            </div>
            <div className="divide-y divide-gray-200" data-id="element-689">
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-690">
                <div className="font-semibold text-[#2c3e50]" data-id="element-691">Approach</div>
                <div data-id="element-692">
                  <span className="text-red-600 font-bold" data-id="element-693">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-694">
                    Templates & formulas
                  </span>
                </div>
                <div data-id="element-695">
                  <span className="text-green-600 font-bold" data-id="element-696">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-697">
                    Custom strategy for YOUR audience
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-698">
                <div className="font-semibold text-[#2c3e50]" data-id="element-699">Research</div>
                <div data-id="element-700">
                  <span className="text-red-600 font-bold" data-id="element-701">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-702">Quick Google search</span>
                </div>
                <div data-id="element-703">
                  <span className="text-green-600 font-bold" data-id="element-704">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-705">
                    Deep audience analysis
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-706">
                <div className="font-semibold text-[#2c3e50]" data-id="element-707">
                  Writing Style
                </div>
                <div data-id="element-708">
                  <span className="text-red-600 font-bold" data-id="element-709">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-710">Corporate & formal</span>
                </div>
                <div data-id="element-711">
                  <span className="text-green-600 font-bold" data-id="element-712">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-713">
                    Human & conversational
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-714">
                <div className="font-semibold text-[#2c3e50]" data-id="element-715">Focus</div>
                <div data-id="element-716">
                  <span className="text-red-600 font-bold" data-id="element-717">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-718">Industry jargon</span>
                </div>
                <div data-id="element-719">
                  <span className="text-green-600 font-bold" data-id="element-720">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-721">
                    Revenue generation
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-722">
                <div className="font-semibold text-[#2c3e50]" data-id="element-723">Follow-up</div>
                <div data-id="element-724">
                  <span className="text-red-600 font-bold" data-id="element-725">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-726">Deliver & disappear</span>
                </div>
                <div data-id="element-727">
                  <span className="text-green-600 font-bold" data-id="element-728">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-729">
                    Optimize & improve
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 p-6" data-id="element-730">
                <div className="font-semibold text-[#2c3e50]" data-id="element-731">
                  Communication
                </div>
                <div data-id="element-732">
                  <span className="text-red-600 font-bold" data-id="element-733">❌</span>
                  <span className="ml-2 text-red-600" data-id="element-734">
                    Poor or non-existent
                  </span>
                </div>
                <div data-id="element-735">
                  <span className="text-green-600 font-bold" data-id="element-736">✅</span>
                  <span className="ml-2 text-green-600 font-semibold" data-id="element-737">
                    Regular updates & collaboration
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Guarantee Section */}
      <section className="py-20 bg-[#1e1e1e] text-white" data-id="element-738">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-739">
          <div className="max-w-3xl mx-auto text-center" data-id="element-740">
            <h2 className="text-4xl font-bold mb-6" data-id="element-741">Our Promise To You</h2>
            <p className="text-xl opacity-90 mb-6" data-id="element-742">
              We're so confident in our approach that we offer something most
              copywriters won't.
            </p>
            <div className="bg-[#f9fafb] p-8 rounded-xl my-10 transition-all duration-300 hover:-translate-y-2 hover:shadow-lg transform hover:scale-105" data-id="element-743">
              <h3 className="text-2xl font-bold mb-4 text-[#2c3e50]" data-id="element-744">
                ✅100% Satisfaction Guarantee✅
              </h3>
              <p className="text-lg text-gray-600" data-id="element-745">
                If you're not completely happy with the copy we deliver, We'll
                revise it until you love it. Your success is our success.
              </p>
            </div>
            <p className="text-lg opacity-90 mb-4" data-id="element-746">
              Most copywriters deliver the work and hope for the best.
            </p>
            <p className="text-lg opacity-90" data-id="element-747">
              We deliver the work and make sure it actually works for your
              business.
            </p>
          </div>
        </div>
      </section>
    </>;
};